import { render, staticRenderFns } from "./AdvancedVideoSelector.vue?vue&type=template&id=4fec3cd0"
import script from "./AdvancedVideoSelector.vue?vue&type=script&lang=js"
export * from "./AdvancedVideoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports